export const initialValues = {
  name: "",
  is_active: 1,
};
